export default __webpack_public_path__ + "static/media/4-3.8d005851.jpg";